import type { FirebaseApp } from 'firebase/app';
import type * as firebaseAuth from 'firebase/auth';

type FirebaseAppModule = { initializeApp: (config: Record<string, unknown>) => FirebaseApp };

export default function importFirebase(): Promise<[FirebaseAppModule, typeof firebaseAuth]> {
  return Promise.all([import('firebase/app') as Promise<FirebaseAppModule>, import('firebase/auth')]);
}
